import { getTrackers } from "@base/config";
import { isTrackerOn } from "../activeTrackers";
import { createBigoChannel } from "./bigo";
import { createGoogleAdsChannel } from "./googleAds";
import { createMetaChannel } from "./meta";
import { createSnapChannel } from "./snap";
import type { AdChannel } from "./types";

export type { AdChannel } from "./types";

let channels: AdChannel[] | undefined;

/** Ad channels switched on in the app's trackers map (src/trackers.ts). */
export function getAdChannels(): AdChannel[] {
  if (channels) {
    return channels;
  }
  // Built lazily: the app config is registered after module evaluation.
  const trackers = getTrackers();
  const list: AdChannel[] = [];
  if (isTrackerOn("meta")) {
    list.push(createMetaChannel(trackers.meta.pixelID.value));
  }
  if (isTrackerOn("snap")) {
    list.push(createSnapChannel(trackers.snap.pixelID.value));
  }
  if (isTrackerOn("bigo")) {
    list.push(createBigoChannel(trackers.bigo.pixelID.value));
  }
  if (isTrackerOn("googleAds")) {
    list.push(
      createGoogleAdsChannel(
        trackers.googleAds.conversionID.value,
        trackers.googleAds.purchaseLabel.value,
      ),
    );
  }
  channels = list;
  return list;
}
